import {
  FETCH_CNC_VOUCHER_SENT_REPORT,
  FETCH_CNC_VOUCHER_SENT_REPORT_SUCCESS,
  FETCH_CNC_VOUCHER_SENT_REPORT_FAILURE,
  RESET_CNC_VOUCHER_SENT_REPORT,
  RESEND_CNC_VOUCHER,
  RESEND_CNC_VOUCHER_SUCCESS,
  RESEND_CNC_VOUCHER_FAILURE,
} from "./cncVoucherTypes";

export const voucherResendingStatus = {
  inProgress: "inProgress",
  success: "Success",
  failure: "Failure",
};

const initialState = {
  voucherSentReport: undefined,
  error: undefined,
  resendVoucherStatus: {
    status: undefined,
    error: undefined,
  },
};

const cncVoucherReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CNC_VOUCHER_SENT_REPORT:
      return { ...state };
    case FETCH_CNC_VOUCHER_SENT_REPORT_SUCCESS:
      return { ...state, voucherSentReport: action.payload };
    case FETCH_CNC_VOUCHER_SENT_REPORT_FAILURE:
      return { ...state, error: action.payload };
    case RESET_CNC_VOUCHER_SENT_REPORT:
      return initialState;
    case RESEND_CNC_VOUCHER:
      return {
        ...state,
        resendVoucherStatus: {
          ...state.resendVoucherStatus,
          status: voucherResendingStatus.inProgress,
        },
      };
    case RESEND_CNC_VOUCHER_SUCCESS:
      return {
        ...state,
        resendVoucherStatus: {
          ...state.resendVoucherStatus,
          status: voucherResendingStatus.success,
        },
      };
    case RESEND_CNC_VOUCHER_FAILURE:
      return {
        ...state,
        resendVoucherStatus: {
          ...state.resendVoucherStatus,
          status: voucherResendingStatus.failure,
          error: action.payload,
        },
      };
    default:
      return state;
  }
};

export default cncVoucherReducer;
